module.exports = __webpack_public_path__ + "/login_ui/img/li-1797fad3d174be471045bd17af235840.svg";